import { DeviceState } from './device-reducer';
import { DEVICE_ACTION_TYPE, DeviceActions } from './device-type';

export const deviceCreators = {
  setDeviceState: <KeyName extends keyof DeviceState>(key: KeyName, value: DeviceState[KeyName])
    : DeviceActions => ({
      type: DEVICE_ACTION_TYPE.SET_DEVICE_STATE,
      payload: { key, value }
    }),
  callDeviceListTnc: () => ({
    type: DEVICE_ACTION_TYPE.CALL_DEVICE_LIST_TNC
  }),
};
